var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbnkLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #2da04e;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.7,526.1l-24.8-62.8h-123.8l-23.5,62.8h-84l134.2-319.9h75l132.8,319.9h-85.8ZM386.9,291.7l-40.7,109.8h80.4l-39.8-109.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840.2,433.1c0,17.5-3.5,32.2-10.4,44-6.9,11.9-16.1,21.5-27.6,28.7-11.5,7.2-24.5,12.4-39.1,15.6-14.6,3.2-29.6,4.7-45,4.7h-127.4V206.3h127.4c12.3,0,25,1.3,37.9,3.8,12.9,2.6,24.7,6.9,35.2,13.1,10.5,6.2,19.1,14.5,25.8,25.1,6.6,10.5,9.9,23.9,9.9,40.2s-4.8,32.5-14.5,44c-9.6,11.6-22.3,20-37.9,25.1v.9c9,1.5,17.5,4.3,25.5,8.4,8,4.1,14.9,9.3,20.8,15.6,5.9,6.3,10.5,13.7,14,22.1,3.5,8.4,5.2,17.9,5.2,28.5ZM752.5,298.9c0-10.8-4.1-18.7-12.4-23.7-8.3-5-20.6-7.5-36.8-7.5h-37.9v66h41.6c14.5,0,25.7-2.9,33.7-8.8,8-5.9,12-14.5,12-26ZM762.9,425.8c0-13.3-5-22.4-14.9-27.6-9.9-5.1-23.2-7.7-39.8-7.7h-42.9v73.2h43.4c6,0,12.3-.5,18.7-1.6,6.5-1.1,12.3-2.9,17.6-5.6,5.3-2.7,9.6-6.6,12.9-11.5,3.3-5,5-11.4,5-19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.4,873.7l-128.8-209.2h-1.4l1.8,209.2h-75v-319.9h88.1l128.3,208.7h1.4l-1.8-208.7h75v319.9h-87.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M762.7,873.7l-118.8-147.3h-.9v147.3h-75.4v-319.9h75.4v130.1h1.4l114.3-130.1h96.7l-137.8,147.3,145.9,172.6h-100.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbnkLogo);
export default __webpack_public_path__ + "static/media/ABNK-logo.2a35c9fafde82a625f66dc59a92122e4.svg";
export { ForwardRef as ReactComponent };